export default __webpack_public_path__ + "static/media/DeleteIcon.bd7f56e1.svg";